<template>
  <div class="_report">
    <ReportFilter
      v-model="filter"
      :filterHook="filterHook"
      :config="filterConfig"
      :esFilter="productServiceFilter"
    />
    <ElasticList
      v-if="filter.isReady"
      ref="elasticListRef"
      :filter="productServiceFilter"
      :list="list"
      :rawFilter="filter.filter"
    />
  </div>
</template>

<script>
import _ from "lodash";
import ElasticList from "@/components/DynamicForm/ElasticList";
import ReportFilter from "@/pages/Reports/include/ReportFilter";
import ReportBonusConfig from "./include/configs/ReportBonusConfig";
import ReportConfigDefaults from "./include/configs/ReportConfigDefaults";

export default {
  components: {
    ElasticList,
    ReportFilter,
  },
  data() {
    return {
      filter: {
        isReady: false,
        filter: null,
      },
      list: ReportBonusConfig(this),
      services: [],
      filterConfig: {
        formatResponse : this.formatResponse,
        columns: ReportBonusConfig(this).columns,  
        csv: {
          reportName: 'Bonus',
          listQueryId: ReportBonusConfig(this).listQueryId,
          responseFieldName: ReportBonusConfig(this).responseFieldName
        }  
      },
    };
  },
  computed: {
    /**
     * ES filter to use esData field
     * return negative filter when no services are found
     */
    productServiceFilter() {
      if (!this.services.length) {
        return {
          match_phrase: {
            id: -1,
          },
        };
      }
      const ids = [];
      for (let i = 0; i < this.services.length; i++) {
        ids.push({
          match_phrase: {
            'esData.service.id': this.services[i].id
          }
        });
      }
      return {
        bool: {
          must: [
            {
              bool: {
                should: ids,
              },
            },
          ],
        },
      };
    },
  },
  methods: {
    filterHook(services, queryParams, form) {
      this.services = services;
    },
    filterResponse(result) {
      // const productServices = this.$reduce(result, "data.searchProductServices.items");
      // const serviceIds = [];
      // this.services.forEach(_service => {
      //   serviceIds.push(_service.id);
      // });
      // const filteredProductServices = _.filter(productServices, (ps) => _.includes(serviceIds, ps.service.id));
      // result.data.searchProductServices.items = filteredProductServices;
      // result.data.searchProductServices.total = filteredProductServices.length;
      return result;
    },
    formatResponse(data) {
      const productServices = this.$reduce(data, "searchProductServices.items");
      let items = [];
      if (productServices && productServices.length) {
        
        items = productServices.map((_productServices) => {
          if (_productServices && _productServices.product && _productServices.product.billToService && _productServices.product.billToService.id) {
            const serviceIndex = this.services.findIndex(_loopService => _loopService.id == _productServices.product.billToService.id);
            if (-1 != serviceIndex) {
              _productServices.portfolio = _.cloneDeep(this.services[serviceIndex].portfolio);
            }
          }          
          const row = {
            processor: this.$reduce(_productServices, "product.billToService.processor"),
            status: this.$reduce(_productServices, "product.billToService.status"),
            company: this.$reduce(_productServices, "product.billToService.account.company.name"),
            portfolio: this.$reduce(_productServices, "portfolio.name"),
            account: this.$reduce(_productServices, "product.billToService.account.name"),
            merchantNumber: this.$reduce(_productServices, "product.billToService.merchantNumber"),
            approvalDate: this.$reduce(_productServices, "product.billToService.approvalDate"),
            isRestructured: this.$reduce(_productServices, "product.billToService.isRestructured"),
            proposalStatementValue: this.$reduce(_productServices, "product.billToService.proposalStatementValue"),
            avgTrxAmount: this.$reduce(_productServices, "product.billToService.avgTrxAmount"),
            category: this.$reduce(_productServices, "product.productOption.category"),
            model: this.$reduce(_productServices, "product.name"),
            cashDiscount: this.$reduce(_productServices, "product.cashDiscount"),
            billToService: this.$reduce(_productServices, "product.billToService.name"),
            billingMethod: this.$reduce(_productServices, "product.billingMethod"),
          };
          
          // remove null values - set them to blank
          Object.keys(row).map(_key => {
            if (null === row[_key]) {
              row[_key] = '';
            }
          });
          
          return row;
        });
      }

      // sort results
      const elasticListRef = this.$refs.elasticListRef;
      items = _.sortBy(items, elasticListRef.currentSort);
      if ('desc' == elasticListRef.currentSortDir) {
        return items.reverse();
      }
      return items;
    }
  }
};
</script>
